import { useCallback, useState } from 'react';
import { fetchLogin } from '@/store/auth/actions';

export const ConnectWithCalForm = ({ variant, user, children, dispatch }) => {
  const [csrfToken, setCsrfToken] = useState('');

  const onSubmit = useCallback(
    async (event) => {
      const form = event.target;

      // proceed with normal submit if CSRF token is already there
      if (form.elements['authenticity_token']?.value) return;

      // otherwise, fetch the CSRF token, attach it to the form, then submit
      event.preventDefault();

      const { data } = await dispatch(fetchLogin()).unwrap();
      const { csrf_token } = data;
      if (csrf_token) {
        setCsrfToken(csrf_token);
        setTimeout(() => form.submit());
      }
    },
    [setCsrfToken, dispatch]
  );

  const OauthParams = new URLSearchParams({
    for: 'calendar',
    origin: window.location.href,
  });

  return (
    <form
      method="post"
      action={`/api/v1/auth/${
        variant === 'gcal' ? 'google_oauth2' : 'microsoft_graph'
      }?${OauthParams}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      {variant === 'gcal' && (
        <input type="hidden" name="login_hint" value={user?.email || ''} />
      )}
      {children}
    </form>
  );
};
